(function (app, ng) {

    app.controller("addEventController", addEventController);

    addEventController.$inject = ["$mdDialog", "$q", "moment", "marketingTrackerEventGroupApi", "marketingTrackerAncillaryEventGroupApi", "_", "$window", "figToaster", "$stateParams"];
    function addEventController($mdDialog, $q, moment, marketingTrackerEventGroupApi, marketingTrackerAncillaryEventGroupApi, _, $window, figToaster, $stateParams) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false
                },
                eventGroup: {
                    UserId: $ctrl.user.Id,
                    TypeId: $ctrl.eventType.Id
                },
                newEvent: {},
                //dates: [new Date()],
                close: close,
                addEvent: addEvent,
                addMultiEvent: addMultiEvent,
                add: add,
                multiEvents: false,
                error: error
            });

        function close() {
            $mdDialog.cancel();
        }

        function add() {
            if ($ctrl.multiEvents === true) {
                addMultiEvent();
            }
            else {
                addEvent();
            }
        }

        //function addMultiEvent() {
        function addEvent() {
            $ctrl.ui.saving = true;
            var promises = [];
            var subpromises = [];

            var eventGroups = [];
            var api = !$ctrl.eventType.IsAncillary ? marketingTrackerEventGroupApi : marketingTrackerAncillaryEventGroupApi;

            ng.forEach(_.split($ctrl.dates, ","), function (date) {
                date = new Date(date);
                date.setHours(0, 0, 0, 0);
                promises.push(api.create($ctrl.eventGroup).then(function (evtGroup) {
                    evtGroup.Events = [];
                    evtGroup.EventType = $ctrl.eventType;
                    if (api === marketingTrackerEventGroupApi) {
                        subpromises.push(api.addEvent(evtGroup.Id, {
                            Title: $ctrl.newEvent.Name,
                            EventDate: date
                        }).then(function (event) {
                            evtGroup.Events.push(event);
                            eventGroups.push(evtGroup);
                        }));
                    }
                    else {
                        subpromises.push(api.addAncillaryEvent(evtGroup.Id, {
                            Description: $ctrl.newEvent.Name,
                            EventDate: date
                        }).then(function (event) {
                            evtGroup.Events.push(event);
                            eventGroups.push(evtGroup);
                        }));
                    }
                }));
            });

            if (!!$ctrl.eventGroup.PlanningDate) {
                var date = new Date($ctrl.eventGroup.PlanningDate);
                date.setHours(0, 0, 0, 0);
                promises.push(api.create($ctrl.eventGroup).then(function (evtGroup) {
                    evtGroup.Events = [];
                    evtGroup.EventType = $ctrl.eventType;
                    if (api === marketingTrackerEventGroupApi) {
                        subpromises.push(api.addEvent(evtGroup.Id,
                            {
                                Title: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (event) {
                                evtGroup.Events.push(event);
                                eventGroups.push(evtGroup);
                            }));
                    }
                    else {
                        subpromises.push(api.addAncillaryEvent(evtGroup.Id,
                            {
                                Description: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (event) {
                                evtGroup.Events.push(event);
                                eventGroups.push(evtGroup);
                            }));
                    }
                }));
            }
            $q.all(promises)
                .then(function () {
                    $q.all(subpromises).then(function () {
                        $ctrl.saving = false;
                        $mdDialog.hide(eventGroups);
                    });
                }).catch(function () {
                    showToast('There was a problem adding your event. Please try again shortly.', 'is-error');
                }).finally(function () {
                    $ctrl.ui.saving = false;
                });
        }

        function addMultiEvent() {
            var dates = $ctrl.dates;

            $ctrl.ui.saving = true;
            var api = !$ctrl.eventType.IsAncillary ? marketingTrackerEventGroupApi : marketingTrackerAncillaryEventGroupApi;

            api.create($ctrl.eventGroup).then(function (response) {
                var promises = [];
                $ctrl.eventGroup.Id = response.Id;
                $ctrl.eventGroup.EventType = $ctrl.eventType;
                $ctrl.eventGroup.Events = [];

                ng.forEach(_.split(dates, ","),
                    function (date) {
                        date = new Date(date);
                        date.setHours(0, 0, 0, 0);
                        if (api === marketingTrackerEventGroupApi)
                            promises.push(api.addEvent(response.Id,
                                {
                                    Title: $ctrl.newEvent.Name,
                                    EventDate: date
                                }).then(function (response) {
                                    $ctrl.eventGroup.Events.push(response);
                                }));
                        else
                            promises.push(api.addAncillaryEvent(response.Id,
                                {
                                    Description: $ctrl.newEvent.Name,
                                    EventDate: date
                                }).then(function (response) {
                                    $ctrl.eventGroup.Events.push(response);
                                }));
                    });

                if (!!$ctrl.eventGroup.PlanningDate) {
                    var date = new Date($ctrl.eventGroup.PlanningDate);
                    date.setHours(0, 0, 0, 0);
                    if (api === marketingTrackerEventGroupApi)
                        promises.push(api.addEvent(response.Id,
                            {
                                Title: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (response) {
                                $ctrl.eventGroup.Events.push(response);
                            }));
                    else
                        promises.push(api.addAncillaryEvent(response.Id,
                            {
                                Description: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (response) {
                                $ctrl.eventGroup.Events.push(response);
                            }));
                }

                $q.all(promises).then(function () {
                    $ctrl.saving = false;
                    $mdDialog.hide($ctrl.eventGroup);
                });
            }).catch(function () {
                showToast('is-error', 'There was a problem adding your event. Please try again shortly.');
            }).finally(function () {
                $ctrl.ui.saving = false;
            });
        }

        function showToast(message, toastClass) {
            return figToaster.showSimple(message, "top", toastClass);
        }

        function error($event) {
            var errorMsg = $mdDialog.alert({
                title: "We're sorry, there was an error.",
                targetEvent: $event,
                ariaLabel: "Confirm event error",
                ok: "Yes",
                multiple: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(errorMsg).then(function () {
                $mdDialog.hide({
                    eventGroup: $ctrl.eventGroup,
                    event: $ctrl.event
                });
                $window.location.reload();
            });
        }

        function init() {
            var initDate = !!$stateParams.date ? moment($stateParams.date) : moment();
            $ctrl.ui.startDate = initDate.toDate();
        }
        init();
    }

})(window.app, window.angular); //jshint ignore:line